'use client';

import { c as _c } from "react/compiler-runtime";
import type { Commission } from '@svenskaspelab/poolbetting/schema/input';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '@svenskaspelab/ui/react/select';
import type { ReactNode } from 'react';
type PixWalletCommissionSelectorProps = {
  commissionValueOptions: number[];
  onValueChange: (value: number) => void;
  selectedCommissionPercent: number;
  commissionPercent: Commission;
};

/**
 * Component responsible for rendering the commission selector in the PixWallet.
 *
 * @param root0 props
 * @param root0.commissionValueOptions list of commission value options
 * @param root0.onValueChange callback for when the selected commission changes
 * @param root0.selectedCommissionPercent the currently selected commission percentage
 * @param root0.commissionPercent the commission percent for the activated draw, used to determine if some options should be disabled
 * @returns renders the commission selector
 */
export function PixWalletCommissionSelector(t0) {
  const $ = _c(15);
  const {
    commissionValueOptions,
    onValueChange,
    selectedCommissionPercent,
    commissionPercent
  } = t0;
  const selectedValue = `${selectedCommissionPercent}`;
  let t1;
  if ($[0] !== onValueChange) {
    t1 = value => {
      if (value === null) {
        return;
      }
      onValueChange(Number.parseInt(value, 10));
    };
    $[0] = onValueChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SelectTrigger className="w-full" aria-invalid={false}><SelectValue placeholder={"V\xE4lj avgift"} /></SelectTrigger>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectLabel>Spelpott</SelectLabel>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== commissionPercent || $[5] !== commissionValueOptions) {
    let t5;
    if ($[7] !== commissionPercent) {
      t5 = (commissionValue, index) => <SelectItem key={`commission-${index}`} value={`${index}`} disabled={index > commissionPercent}>{index}% (Spelpott: {commissionValue} kr)</SelectItem>;
      $[7] = commissionPercent;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = commissionValueOptions.map(t5);
    $[4] = commissionPercent;
    $[5] = commissionValueOptions;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <SelectContent className="z-60"><SelectGroup>{t3}{t4}</SelectGroup></SelectContent>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== selectedValue || $[12] !== t1 || $[13] !== t5) {
    t6 = <Select value={selectedValue} onValueChange={t1}>{t2}{t5}</Select>;
    $[11] = selectedValue;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}